import React from 'react'
import SideBar from '../../components/commoncomponents/SideBar'
import Header from '../../components/commoncomponents/Header'
import Footer from '../../components/commoncomponents/Footer'
import { Layout, Content, ContentBody } from '../../assets/styled-components/layout'
import CreateAssetCategory from '../../components/assetcategorycomponents/CreateAssetCategory'

function AssetCategoryRegister({renderPageContent}) {
    return (
        <>
                        {/*Dynamic content goes here */}
                        <CreateAssetCategory renderPageContent={renderPageContent}/>
                

        </>
    )
}

export default AssetCategoryRegister;